
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.1 45.1V14.6c0-.4-.1-1.4-.6-1.5h-.2C37.5 13 22.6 13 7.8 13h-.2c-.5.2-.6 1.2-.6 1.6v31.1c0 .4.1 1.6.7 1.6h44.7c.6-.1.8-1.3.7-2.2zM29.9 32.5c.1.1.2.1.4 0 7.1-5.3 14.2-10.5 21.4-15.8V44H8.4V16.7c7.1 5.3 14.3 10.5 21.5 15.8zM12.1 16.2H48c-2.3 1.7-4.6 3.4-7 5.1-2.5 1.8-4.9 3.6-7.4 5.4-.7.5-3.3 2.8-3.6 2.8-.3 0-2.7-2.1-3.3-2.5-2.6-1.9-5.1-3.8-7.7-5.6-2.3-1.8-4.6-3.5-6.9-5.2z"}})])
          )
        }
      }
    